import React from 'react';
import { BookOpen, ExternalLink } from 'lucide-react';

/**
 * CitationDisplay - Shows heading and citation reference for a question
 * 
 * @param {string} heading - Section heading (e.g., "See Chapter 2, Stratum Basale")
 * @param {object} citation - Citation object with text and link
 * @param {string} citation.text - Citation text
 * @param {string} citation.link - URL to external resource
 */
const CitationDisplay = ({ heading, citation }) => {
    if (!heading && !citation) return null;

    return (
        <div className="mt-6 pt-4 border-t-2 border-gray-200">
            {/* Heading - Where to read more */}
            {heading && (
                <div className="mb-3 flex items-start gap-2">
                    <BookOpen className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                    <div>
                        <p className="text-sm font-semibold text-gray-700 mb-1">
                            Read More:
                        </p>
                        <p className="text-sm text-gray-600 italic">
                            {heading}
                        </p>
                    </div>
                </div>
            )}

            {/* Citation - Source reference */}
            {citation && (
                <div className="bg-blue-50 border-l-4 border-blue-500 p-3 rounded-r-lg">
                    <p className="text-xs font-semibold text-blue-900 mb-1">
                        SOURCE:
                    </p>
                    {citation.link ? (
                        <a
                            href={citation.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm text-blue-700 hover:text-blue-900 hover:underline flex items-start gap-2 group"
                        >
                            <span className="flex-1">{citation.text}</span>
                            <ExternalLink className="w-4 h-4 flex-shrink-0 mt-0.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                        </a>
                    ) : (
                        <p className="text-sm text-blue-700">
                            {citation.text}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default CitationDisplay;
